
export type GetUserProfile401 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
